/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateMerchantTwoFactorStateRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {UpdateMerchantTwoFactorStateResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const updateMerchantTwoFactorState = (request: UpdateMerchantTwoFactorStateRequest, options?: CashRequestOptions) => post<UpdateMerchantTwoFactorStateRequest, UpdateMerchantTwoFactorStateResponse>("/2.0/cash/update-merchant-two-factor-state", request, {...options, rejectOnError: true })